var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 706,
    viewBox: "0 0 1440 706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 706
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 706,
    fill: "#C20001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_475)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 706,
    fill: "#C20001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 706,
    fill: "url(#paint0_radial_99_475)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 720,
    cy: 622,
    r: 192,
    stroke: "url(#paint1_linear_99_475)",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 720,
    cy: 622,
    r: 246,
    stroke: "url(#paint2_linear_99_475)",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 720,
    cy: 622,
    r: 301,
    stroke: "url(#paint3_linear_99_475)",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.11 522.384C1275.47 522.165 1275.78 521.706 1276.03 521.196C1279.31 522.518 1281.61 525.642 1281.61 529.284C1281.61 534.124 1277.55 538.047 1272.53 538.047C1270.47 538.047 1268.57 537.386 1267.05 536.272C1266.55 536.038 1266.13 535.814 1265.8 535.63C1265.28 535.346 1264.93 535.159 1264.72 535.188C1264.09 535.274 1264.27 535.842 1264.44 536.359C1264.55 536.709 1264.66 537.036 1264.49 537.171C1264.33 537.312 1263.78 536.796 1263.14 536.193C1262.26 535.372 1261.22 534.391 1260.73 534.686C1260.34 534.919 1260.71 535.551 1261.18 536.326L1261.21 536.383C1261.41 536.71 1261.63 537.044 1261.84 537.348C1262.26 537.966 1262.6 538.464 1262.43 538.548C1262.22 538.65 1260.8 537.701 1259.6 536.383C1259.13 535.875 1258.68 535.323 1258.27 534.811V534.811C1257.35 533.689 1256.59 532.755 1256.16 532.866C1255.65 532.999 1256.04 534.045 1256.61 535.051C1256.88 535.522 1257.19 536.001 1257.46 536.416V536.416C1257.89 537.062 1258.21 537.551 1258.09 537.612C1257.93 537.693 1256.55 536.362 1255.61 534.686C1255.05 533.69 1254.58 532.589 1254.2 531.698C1253.79 530.732 1253.49 530.012 1253.28 529.94C1252.58 529.688 1252.58 531.098 1252.86 533.133C1252.9 533.398 1252.96 533.677 1253.02 533.96C1255.75 542.663 1264.13 549 1274.04 549C1286.17 549 1296 539.519 1296 527.824C1296 516.693 1287.1 507.568 1275.78 506.713C1275.8 506.189 1276.07 505.149 1276.07 505.149C1276.07 505.149 1278.07 500.384 1278.18 499.365C1278.18 499.298 1278.19 499.224 1278.2 499.146C1278.32 498.046 1278.56 496 1276.77 496C1275.82 496 1275.37 496.699 1274.87 497.499V497.499C1274.67 497.806 1274.47 498.128 1274.22 498.43C1272.45 500.611 1269.48 503.334 1267.79 504.785C1264.22 507.851 1260.72 510.371 1258.68 511.841L1258.68 511.841C1257.75 512.509 1257.12 512.96 1256.93 513.147C1255.46 514.552 1250.22 523.875 1250.22 523.875C1250.22 523.875 1248.53 526.866 1249.13 527.473C1249.73 528.08 1251.18 527.941 1251.18 527.941C1251.18 527.941 1270.7 523.525 1272.45 523.177C1272.92 523.083 1273.25 523.029 1273.51 522.987C1274.2 522.875 1274.33 522.854 1275.11 522.384ZM1261.31 516.71C1260.26 517.692 1258.52 520.036 1258.52 520.036C1258.52 520.036 1261.75 520.232 1263.53 518.565C1265.31 516.898 1264.9 514.057 1264.9 514.057C1264.9 514.057 1262.35 515.728 1261.31 516.71Z",
    fill: "#CA2020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.447 331.055C366.437 331.028 366.458 331 366.487 331H383.941C383.959 331 383.976 331.012 383.981 331.029L391.998 356.131C392.007 356.158 391.986 356.185 391.957 356.185H380.338C380.324 356.185 380.313 356.198 380.317 356.211L386.981 378.947C386.994 378.991 386.935 379.02 386.906 378.983L361.009 345.605C360.987 345.578 361.008 345.539 361.043 345.539H371.588C371.603 345.539 371.613 345.525 371.608 345.511L366.447 331.055Z",
    fill: "#CA2020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.56 229.474C1224.25 226.989 1222.9 221.881 1222.9 221.881C1222.9 221.881 1221.93 226.042 1220.41 227.58C1219.11 228.892 1217.51 229.802 1215.23 230.041C1217.1 229.152 1218.38 227.296 1218.38 225.151C1218.38 222.141 1215.85 219.7 1212.73 219.7C1209.61 219.7 1207.08 222.141 1207.08 225.151C1207.08 225.974 1207.27 226.753 1207.61 227.453C1205.65 225.926 1205.35 223.48 1205.35 223.48C1205.35 223.48 1203.17 232.36 1209.17 236.538C1215.18 240.715 1226.95 237.125 1226.95 237.125C1226.95 237.125 1210.11 248.75 1197.63 236.097C1186.88 225.198 1194.83 210.848 1194.83 210.848C1194.83 210.848 1194.48 212.179 1194.48 213.724C1194.48 215.27 1195.34 216.445 1195.34 216.445C1195.34 216.445 1197.88 211.178 1199.87 209.035C1201.74 207.008 1204.09 205.363 1206.12 203.943C1207.69 202.85 1209.06 201.889 1209.88 200.989C1214.4 196.031 1211.63 187 1211.63 187C1211.63 187 1216.72 191.406 1218.15 197.097C1218.69 199.267 1218.34 201.735 1218.03 203.942C1217.52 207.525 1217.11 210.421 1220.77 210.233C1226.68 209.929 1221.54 200.989 1221.54 200.989C1221.54 200.989 1234.95 207.902 1233.95 219.994C1232.94 232.086 1219.29 234.835 1219.29 234.835C1219.29 234.835 1222.86 231.959 1223.56 229.474Z",
    fill: "#CA2020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.427 511.848C282.368 512.051 277.721 512.051 276.142 511.848C263.824 510.263 254 501.457 254 489.553C254 477.65 264.074 468 276.5 468C288.926 468 299 477.65 299 489.553C299 495.089 296.821 500.138 293.24 503.955C292.267 504.992 293.601 505.719 294.957 506.457C296.287 507.182 297.637 507.918 296.852 508.967C295.988 510.124 291.3 511.604 286.427 511.848ZM273.336 486.859C273.336 488.719 271.762 490.227 269.82 490.227C267.879 490.227 266.305 488.719 266.305 486.859C266.305 485.612 267.013 484.523 268.065 483.941C268.125 485.562 269.489 486.859 271.162 486.859H273.336V486.859ZM284.232 483.941C284.172 485.562 282.808 486.859 281.135 486.859H278.961V486.859C278.961 488.719 280.535 490.227 282.477 490.227C284.418 490.227 285.992 488.719 285.992 486.859C285.992 485.612 285.284 484.523 284.232 483.941Z",
    fill: "#CA2020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1091.22 441.872C1091.05 441.711 1090.88 441.547 1090.71 441.38C1081.76 432.554 1081.76 418.243 1090.71 409.417C1099.65 400.59 1128.16 400 1128.16 400C1128.16 400 1132.05 432.554 1123.1 441.38C1115.16 449.219 1102.83 450.096 1093.9 444.011L1101.1 435.303L1112.59 432.854L1103.21 431.928L1109.17 425.936L1115.96 424.469L1110.59 422.9L1115.96 413.344L1108.33 421.795L1105.38 417.69L1106.41 424.469L1101.1 430.385L1098.63 422.9V432.854L1091.22 441.872Z",
    fill: "#CA2020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1347.47 335.712L1333.92 329L1334.33 344.003L1347.13 350.34L1347.47 335.712ZM1362.52 344.185L1362.35 329.062L1349.17 336.238L1349.33 350.518L1362.52 344.185ZM1362.51 360.362L1375.57 352.893L1362.51 346.022L1349.45 352.881L1362.51 360.362ZM1347.12 352.893L1334.07 360.362L1321 352.881L1334.06 346.022L1347.12 352.893ZM1362.72 376.557L1349.16 369.844L1349.51 355.216L1362.31 361.554L1362.72 376.557ZM1334.21 361.569L1334.39 376.693L1347.57 369.517L1347.41 355.237L1334.21 361.569Z",
    fill: "#CA2020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220 345.548C220 355.187 212.165 363 202.5 363C192.835 363 185 355.187 185 345.548C185 336.174 201.553 310.429 202.461 309.024C202.482 308.992 202.518 308.992 202.539 309.024C203.447 310.429 220 336.174 220 345.548ZM199.583 357.405C190.702 355.46 192.222 345.613 192.222 345.613C192.222 345.613 194.647 351.557 200.532 353.483C206.416 355.408 213.528 352.584 213.528 352.584C213.528 352.584 208.463 359.35 199.583 357.405Z",
    fill: "#CA2020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.754 103C396.786 103 402.806 99.0545 405.291 93.4613C405.321 93.3931 395.313 96.0872 395.632 95.1348C395.775 94.7096 401.91 92.4468 406.38 89.8076C408.949 88.2906 410.132 85.0793 410.132 85.0793C410.132 85.0793 405.803 87.201 403.615 87.7391C399.206 88.8239 395.325 88.7071 395.325 88.594C395.325 88.3496 401.77 87.1133 410.727 81.6022C414.941 79.01 416.085 74.5449 416.085 74.5449C416.085 74.5449 411.453 77.3307 408.653 78.2504C402.012 80.4315 395.951 81.0887 395.951 80.7936C395.951 80.1617 401.285 78.6811 406.939 75.9149C409.879 74.4767 412.425 72.5977 415.376 70.508C420.204 67.0891 421 61 421 61C421 61 416.238 64.1008 413.914 65.1305C404.326 69.3796 395.859 71.6084 389.754 72.091C380.539 72.8194 373 79.3109 373 87.7391C373 96.1675 380.501 103 389.754 103Z",
    fill: "#CA2020"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_99_475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(793.5 781.564) rotate(-90) scale(653.05 1332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0001",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_475",
    x1: 815,
    y1: 334,
    x2: 516,
    y2: 729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81414",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_475",
    x1: 840.147,
    y1: 257.765,
    x2: 462,
    y2: 757.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81414",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_99_475",
    x1: 865.76,
    y1: 180.118,
    x2: 407,
    y2: 786.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81414",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRed);
export default __webpack_public_path__ + "static/media/bg-red.d8a71d40ec7f8061d9cd70b20c0a78b8.svg";
export { ForwardRef as ReactComponent };